   /**
  * @description: 用户管理相关api
  * @author: lzc
  * @createTime: lzc(2021-01-22)
  * @updateTime: name(xxxx-xx-xx)
  */

import * as API from '.'

// 前后端分离开发，本地调试使用的url
// let url = '/api1/v1/admin/administrator_manage/';

// 前后端分离开发，远程调试、发布运行使用的url
let url = 'api/user/';


export default {
  
  //用户登录，获取访问token、刷新token、token刷新时间
  login: params => {
    return API.POST( url + 'login', params)
  },
  
  //用户token更新，获取访问token、token刷新时间
  tokenRefresh: params => {
    return API.POST( url + 'tokenRefresh', params)
  },
  
  //用户密码修改
  passwordUpdate: params => {
    return API.POST( url + 'passwordUpdate', params)
  },
  
  //用户退出登录
  logout: params => {
    return API.POST( url + 'logOut', params)
  },
  
  //添加用户
  addUser: params => {
    return API.POST(url + 'addUser', params)
  },

  //修改用户
  updateUser: params => {
    return API.POST(url + 'updateUser', params)
  },

  //删除用户
  delUser: params => {
    return API.POST(url + 'delUser', params)
  },

  //查询用户
  getUser: params => {
    return API.POST(url + 'getUser', params)
  },

  //获取所有用户
  getUsers: params => {
    return API.POST(url + 'getUsers', params)
  },

  addPoints: params => {
    return API.POST(url + 'addPoints', params)
  },
  
}



// WEBPACK FOOTER //
// ./src/api/api_user.js